import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';

import * as _ from 'lodash';
import { PledgeProductRead } from '../../definition/interface/Pledge';
import { FormConfig } from '../../definition/types/subscription';
import FormGroupArray from '../../services/FormGroupArray';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: PledgeProductRead & { parameters: any }) {
    let options: AbstractControlOptions = {};
    const formConfig: FormConfig<PledgeProductRead & { parameters: any }> = {
      id: [entity.id],
      type: [entity.type],
      productId: [entity.productId],
      productName: [entity.productName],
      status: [entity.status],
      parameters: this.formBuilder.group({
        avSouscriptionGarantiePlancher: [
          !_.isNil(entity?.parameters?.avSouscriptionGarantiePlancher)
            ? entity?.parameters?.avSouscriptionGarantiePlancher
            : null,
          Validators.required,
        ],
      }),
    };

    return this.formBuilder.group(formConfig, options);
  }
  generate(entity: any[], option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      propertyName: 'products',
    });
  }

  get products() {
    return this.form.get('products') as UntypedFormArray;
  }

  extract() {
    return this.form.value.products;
  }
}
